import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getResidueList } from '../../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditGuideDetailModal from './Add_Edit/AddEditGuideDetailModal';
import DeleteGuideDetailModal from './Delete/DeleteGuideDetail';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import AddEditResidueBeachCleaningModal from './Add_Edit/AddEditResidueBeachCleaningModal';
import TraceabilityModal from '../../Traceability/TraceabilityModal';

const GuideDetailsRegisterList = ({
	unitMeasurementResidueCollected,
	finalDestinationSelected,
	residueType,
	guideDetailsList,
	handlerSetGuideDetailsList,
}) => {
	const [dataGuideDetail, setDataGuideDetail] = useState(null);
	const [idsSelectedItem, setIdsSelectedItem] = useState({});
	const [residueCollectedSelectedList, setResidueCollectedSelectedList] = useState([]);
	const isLoadingList = false;
	const [isEdit, setIsEdit] = useState(false);

	// Delete Residue
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalAddResiduesBeachCleaning, setModalAddResiduesBeachCleaning] = useState(false);
	const [traceOpen, setTraceOpen] = useState(false);
	const [traceGuideId, setTraceGuideId] = useState(null);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	function handleToggleModalAddResiduesBeachCleaning() {
		setModalAddResiduesBeachCleaning(!modalAddResiduesBeachCleaning);
	}

	// Delete Data
	const handleClickDelete = guideDetail => {
		setDataGuideDetail(guideDetail);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = guideDetail => {
		setDataGuideDetail(guideDetail);
		handleToggleModal();
	};

	const toggleTraceModal = useCallback(() => {
		setTraceOpen(prev => {
			if (prev) setTraceGuideId(null);
			return !prev;
		});
	}, []);

	const openTraceForPersistedGuide = useCallback(row => {
		const gid = row?.guide_id;
		if (!gid) return;
		setTraceGuideId(gid);
		setTraceOpen(true);
	}, []);

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'residue',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={() => {
													const residueData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(residueData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										{(cellProps.row.original._id ||
											cellProps.row.original.id) &&
											cellProps.row.original.guide_id && (
											<li className='list-inline-item'>
												<Link
													title='Trazabilidad de la guía'
													to='#'
													onClick={e => {
														e.preventDefault();
														openTraceForPersistedGuide(
															cellProps.row.original
														);
													}}
												>
													<i className='ri-git-branch-line align-bottom me-2 text-muted'></i>
												</Link>
											</li>
										)}
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideDetailData =
														cellProps.row.original;
													handleClickDelete(guideDetailData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Código LER', accessorKey: 'residue.LER', size: 'auto' },
			{ header: 'Residuo', accessorKey: 'residue.name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'amount', size: 'auto' },
			{ header: 'Unidad Medida', accessorKey: 'unit_measurement.name', size: 'auto', },
			{
				header: 'Kg. Guía',
				accessorKey: 'residue_kilograms',
				size: 'auto',
			},
			{
				header: 'Kg. Limpiezas de Playa',
				accessorKey: 'residue_collected_kilograms',
				size: 'auto',
			},
			{
				header: 'Total Kilogramos',
				accessorKey: 'kilograms_total',
				size: 'auto',
			},
		],
		[handleClickEdit, openTraceForPersistedGuide]
	);

	function getIdsItemsSelected() {
		let idsSelectedItemToUpdate = [];
		guideDetailsList.map(guideDetail => {
			if (guideDetail.residue_collected_kilograms != 0) {
				idsSelectedItemToUpdate = [
					...idsSelectedItemToUpdate,
					...guideDetail.residue_collected_ids
				]
			}
		});

		let objectMapIdsSelected = {};
		idsSelectedItemToUpdate.map(id => {
			objectMapIdsSelected[id] = true
		})
		setIdsSelectedItem(objectMapIdsSelected);
	}

	function handleUpdateResiduesCollectedGuideDetails(residuesCollectedList, guideDetailsList) {
		// Update all items residue collected to 0
		let updatedGuideDetailList = guideDetailsList.map(guideDetailList => {
			return {
				...guideDetailList,
				residue_collected_kilograms: 0,
				kilograms_total: guideDetailList.residue_kilograms,
				residue_collected_ids: []
			}
		});

		// Remove items without residue kilograms 
		updatedGuideDetailList = updatedGuideDetailList.filter(guideDetailList => (
			guideDetailList.residue_kilograms != 0
		));

		// Each residue collected update or push new guide detail by residue collected.
		residuesCollectedList.map(residueCollected => {
			const indexGuideDetailFounded = updatedGuideDetailList.findIndex(guideDetail => guideDetail.residue._id === residueCollected.residue._id)

			if (updatedGuideDetailList[indexGuideDetailFounded]) {
				// If exist guide detail update residue collected data

				const residueCollectedKilograms = (
					updatedGuideDetailList[indexGuideDetailFounded].residue_collected_kilograms +
					residueCollected.kilograms
				)
				updatedGuideDetailList[indexGuideDetailFounded] = (
					{
						...updatedGuideDetailList[indexGuideDetailFounded],
						residue_collected_kilograms: residueCollectedKilograms,
						kilograms_total: parseFloat(
							residueCollectedKilograms +
							updatedGuideDetailList[indexGuideDetailFounded].residue_kilograms
						),
						residue_collected_ids: [
							...(updatedGuideDetailList[indexGuideDetailFounded].residue_collected_ids || []),
							...[residueCollected._id]
						]
					}
				)
			} else {
				// If not exist guide detail with residue add new item
				updatedGuideDetailList.push({
					_id: null,
					id: null,
					residue_category_id: residueCollected.residue.residue_category_id,
					residue_id: residueCollected.residue_id,
					residue: residueCollected.residue,
					unit_measurement_id: unitMeasurementResidueCollected._id,
					unit_measurement: unitMeasurementResidueCollected,
					amount: 0,
					residue_kilograms: 0,
					residue_collected_kilograms: residueCollected.kilograms,
					kilograms_total: residueCollected.kilograms,
					residue_collected_ids: [residueCollected._id]
				})
			}
		})
		handlerSetGuideDetailsList(updatedGuideDetailList);
	}

	useEffect(() => {
		if (residueCollectedSelectedList) {
			handleUpdateResiduesCollectedGuideDetails(residueCollectedSelectedList, guideDetailsList)
		}
	}, [residueCollectedSelectedList])

	useEffect(() => {
		getIdsItemsSelected();
	}, [guideDetailsList])

	useEffect(() => {
		getIdsItemsSelected();
	}, [])

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					{/* <div className='d-flex align-items-center residue-list'>
						<h5 className='card-title mb-0 flex-grow-1 '>
							Lista de Residuos
						</h5>
						<div>
							<div className='d-flex flex-wrap gap-2'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => {
										setIsEdit(false);
										setDataGuideDetail({});
										handleToggleModal();
									}}
									type='button'
								>
									<i className={`${Icons.plus} label-icon`}></i> Agregar Residuo
								</button>
								<button
									className='btn btn-label btn-primary'
									onClick={() => {
										setIsEdit(false);
										setDataGuideDetail({});
										handleToggleModalAddResiduesBeachCleaning();
									}}
									type='button'
								>
									<i className={`${Icons.plus} label-icon`}></i> Agregar Residuos De Limpieza
								</button>
							</div>
						</div>
					</div> */}
					<div className='mt-3 my-4'>
						<ODataGrid
							columns={columns}
							data={guideDetailsList || []}
							isLoadingData={isLoadingList}
							customToolbarActions={[
								{
									label: 'Agregar',
									icon: Icons.plus,
									onClick: () => {
										setIsEdit(false);
										setDataGuideDetail({});
										handleToggleModal();
									},
									title: 'Agregar Residuo',
								},
								{
									label: 'Agregar Limpieza',
									icon: Icons.plus,
									onClick: () => {
										setIsEdit(false);
										setDataGuideDetail({});
										handleToggleModalAddResiduesBeachCleaning();
									},
									title: 'Agregar Residuos De Limpieza',
								}
							]}
						/>
					</div>
				</Col>
			</div>

			<AddEditGuideDetailModal
				finalDestinationSelected={finalDestinationSelected}
				residueType={residueType}
				dataGuideDetail={dataGuideDetail}
				handleDataGuideDetail={setDataGuideDetail}
				isEdit={isEdit}
				handleIsEdit={setIsEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				guideDetailsList={guideDetailsList}
				handlerGuideDetailsList={handlerSetGuideDetailsList}
			/>
			<DeleteGuideDetailModal
				guideDetailsList={guideDetailsList}
				handlerGuideDetailsList={handlerSetGuideDetailsList}
				dataGuideDetail={dataGuideDetail}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
			<AddEditResidueBeachCleaningModal
				isOpen={modalAddResiduesBeachCleaning}
				isEdit={modalAddResiduesBeachCleaning}
				handleToggleModal={handleToggleModalAddResiduesBeachCleaning}
				handleResidueCollectedSelectList={setResidueCollectedSelectedList}
				idsSelectedItem={idsSelectedItem}
				handleIdsSelectedItem={setIdsSelectedItem}
			/>
			<TraceabilityModal
				isOpen={traceOpen}
				toggle={toggleTraceModal}
				entityId={traceGuideId}
			/>
		</React.Fragment>
	);
};

export default GuideDetailsRegisterList;
